/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Severity level of the detection
 * @export
 */
export const ControlSeverity5 = {
    Informational: 'INFORMATIONAL',
    Low: 'LOW',
    Medium: 'MEDIUM',
    High: 'HIGH',
    Critical: 'CRITICAL'
} as const;
export type ControlSeverity5 = typeof ControlSeverity5[keyof typeof ControlSeverity5];


export function ControlSeverity5FromJSON(json: any): ControlSeverity5 {
    return ControlSeverity5FromJSONTyped(json, false);
}

export function ControlSeverity5FromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlSeverity5 {
    return json as ControlSeverity5;
}

export function ControlSeverity5ToJSON(value?: ControlSeverity5 | null): any {
    return value as any;
}

